import generateRender from 'shared/utils/generateRender';
import DefaultHeader from './DefaultHeader';

const ModalHeader = generateRender({
  default: DefaultHeader,
});

export default ModalHeader;

